// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Power2 } from 'gsap';
import { hover } from 'app/utils/cssUtils';
import isNumeric from 'isnumeric';
import useSheet from 'app/jss';
import colorUtils from 'color';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import { FRIEND_GROUP_ID, NEW_GROUP_ID } from 'app/constants/friendConstants';
import { setCurrentGroup } from 'app/actions/groupActions';
import IconButton from 'app/components/commons/IconButton';
import Icon from 'app/components/commons/Icon';
import GroupContentsMyFriends from 'app/components/friends/GroupContentsMyFriends';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import AnimatedGroupChild from 'app/components/commons/AnimatedGroupChild';
import GroupContentsNew from 'app/components/friends/GroupContentsNew';
import GroupCardCarousel from 'app/components/friends/groupCardCarousel/GroupCardCarousel';
import t from 'app/utils/translate';

type Props = {
  groups?: Object,
  history: Object,
  classes: Object,
  setCurrentGroup: number => void,
  currentGroupId?: number | string,
  urlGroupId: number | string
};

type State = {
  isSearchingFriends: boolean,
  isOpen: boolean
};

class FriendsGroupMain extends React.Component<Props, State> {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      isSearchingFriends: false,
      isOpen: ![undefined, FRIEND_GROUP_ID, NEW_GROUP_ID].includes(props.currentGroupId)
    };
  }

  static defaultProps = {
    currentGroupId: undefined,
    groups: []
  };

  onSearchStart = () => {
    this.setState({ isSearchingFriends: true });
  };

  onSearchEnd = () => {
    this.setState({ isSearchingFriends: false });
  };

  onOpenChange = isOpen => {
    this.setState({ isOpen });
  };

  render() {
    const { currentGroupId, classes } = this.props;
    const { isOpen } = this.state;

    const isFriendsGroup = currentGroupId === undefined || currentGroupId === FRIEND_GROUP_ID;
    const isNew = currentGroupId === NEW_GROUP_ID;
    const isOpenNow = !isFriendsGroup && !isNew;
    const carouselIsAnimating = isOpenNow !== isOpen;

    return (
      <div className={classes.groupMain}>
        <GroupContentsMyFriends
          onSearchStart={this.onSearchStart}
          onSearchEnd={this.onSearchEnd}
          key="myfriends"
          ref={this.setMyFriendsRef}
          className={classes.myFriendsContainer}
        />
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    backIcon: {
      fontSize: 15,
      marginBottom: 3
    },
    myFriendsContainer: {
      flexGrow: 1,
      flexShrink: 0,
      // zIndex: 1,
      minHeight: 300,
      display: 'flex',
      [theme.mediaQuery.tabletPortraitAndBelow]: {
        flexBasis: 300
      }
    },
    groupMainInner: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      position: 'relative',
      [theme.mediaQuery.tabletLandscapeAndUp]: {
        minHeight: 430
      }
    },
    navOption: {
      display: 'flex',
      alignItems: 'center',
      '& >*:not(:last-child)': {
        marginRight: 5
      },
      [theme.mediaQuery.mobileOnly]: {
        alignItems: 'center',
        '& >*:not(:last-child)': {
          marginRight: 5
        }
      }
    },
    newGroup: {
      [theme.mediaQuery.tabletLandscapeAndUp]: {
        flexGrow: 1,
        maxWidth: '70%',
        width: '100%',
        alignSelf: 'center',
        borderRadius: 8,
        marginBottom: 20
      }
    },
    cardsVisible: {
      display: 'none'
    },
    groupMain: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    nav: {
      display: 'flex',
      marginBottom: 10,
      justifyContent: 'space-between',
      paddingLeft: theme.spacing.small,
      paddingRight: theme.spacing.small
    },
    subHeading: {
      fontSize: 16,
      textTransform: 'uppercase'
    },
    addIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 6,
      height: 16,
      width: 16,
      color: theme.color.white,
      backgroundColor: theme.color.primary,
      borderRadius: '100%',
      transition: 'color 0.2s, background-color 0.2s',
      ...hover({
        color: theme.color.basis6,
        backgroundColor: colorUtils(theme.color.primary)
          .darken(0.1)
          .toString()
      }),
      [theme.mediaQuery.mobileOnly]: {
        height: 24,
        width: 24,
        fontSize: 10,
        marginLeft: 5
      }
    }
  };
}

function mapStateToProps(state: GlobalState, { match }) {
  const gid = match.params.group_id;
  const urlGroupId = isNumeric(gid) ? parseInt(gid, 10) : gid;

  return {
    groups: state.friendGroups.groups,
    currentGroupId: state.friendGroups.currentGroup,
    urlGroupId
  };
}

const actions = {
  setCurrentGroup
};

export default useSheet(applyStyles)(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(FriendsGroupMain)
  )
);
